import { SVGProps, Ref, forwardRef } from 'react';

export const SafeFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 0c5.172 0 7.758 0 9.456 1.49q.296.258.555.554C24 3.742 24 6.328 24 11.5s0 7.758-1.49 9.456a6 6 0 0 1-.554.555c-.544.477-1.179.8-1.96 1.02-.011.6-.057.944-.289 1.176C19.414 24 18.943 24 18 24h-1c-.943 0-1.414 0-1.707-.293-.165-.165-.236-.388-.268-.72-.766.009-1.604.013-2.525.013h-1q-1.378 0-2.526-.013c-.032.332-.102.555-.267.72C8.414 24 7.943 24 7 24H6c-.943 0-1.414 0-1.707-.293-.232-.232-.279-.575-.29-1.176-.78-.22-1.415-.543-1.959-1.02a6 6 0 0 1-.555-.555C0 19.258 0 16.672 0 11.5s0-7.758 1.49-9.456q.258-.296.554-.555C3.742 0 6.328 0 11.5 0zm-5 6.7a3 3 0 0 0-1.683 5.485L4.5 15.7h6l-1.318-3.515A3 3 0 0 0 7.5 6.7m6 5.4h6v-1.8h-6z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SafeFilledSize24Glyph.displayName = 'SafeFilledSize24Glyph';
